export const comments_4791869 = {"data":{"data":[],"links":{}}}